/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
import {handleize} from '@/utilities/handleize';
import {QuizQuestion} from './quiz-question';
import {ChangeEventHandler} from 'preact/compat';

export type QuestionProps = {
  question: QuizQuestion;
  value?: string;
  onChange?: ChangeEventHandler<HTMLInputElement>;
};

function Question({question, value, onChange}: QuestionProps): JSX.Element {
  return (
    <article className="flex flex-col items-center gap-y-4 md:gap-y-6">
      <div>
        {question.title && (
          <h6 className="leading-tight md:text-2xl">{question.title}</h6>
        )}
        {question.bodyHtml && (
          <p
            className="leading-normal"
            dangerouslySetInnerHTML={{__html: question.bodyHtml}}
          ></p>
        )}
      </div>
      <fieldset
        className={`grid w-full ${question.options.length > 3 ? 'grid-cols-2 gap-2' : 'max-w-128 grid-cols-1 gap-3'}`}
      >
        {question.options.map((option, i) => {
          const optionValue =
            option.label ||
            option.image?.alt ||
            option.image?.src ||
            `option-${i}`;

          return (
            <label
              key={option.label}
              className={`${question.options.length > 3 ? 'text-center' : 'text-start'} ${option.image ? 'p-2' : 'p-4'} fast-transition flex flex-col justify-center rounded-lg border border-deep-ocean-blue/70 bg-crisp-white text-sm leading-tight text-deep-ocean-blue shadow-md shadow-deep-ocean-blue/20 has-[:checked]:border-breeze-blue has-[:checked]:bg-light-breeze/10 md:px-8 md:py-4  md:text-base`}
            >
              <input
                onChange={onChange}
                type="radio"
                name={question.name}
                id={handleize(question.name)}
                value={optionValue}
                checked={value === optionValue}
                className="hidden"
              />
              {option.image && (
                <img
                  {...option.image}
                  className="mx-auto mb-2 block h-10 w-auto md:h-16"
                />
              )}
              {option.label}
            </label>
          );
        })}
      </fieldset>
    </article>
  );
}

export default Question;
